import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Upload, FileText, PackageSearch, AlertTriangle, LogOut, Boxes, Sparkles, Truck, Layers, Factory } from "lucide-react";
import { useAuth } from "@/lib/auth";

const items = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/upload", label: "Upload PO", icon: Upload, testid: "nav-upload" },
  { to: "/orders", label: "Purchase Orders", icon: FileText, testid: "nav-orders" },
  { to: "/all-lines", label: "All Decoded Lines", icon: Layers, testid: "nav-all-lines" },
  { to: "/dispatches", label: "Dispatches", icon: Truck, testid: "nav-dispatches" },
  { to: "/tata-dispatch", label: "Tata Dispatch Docs", icon: Factory, testid: "nav-tata-dispatch" },
  { to: "/catalog", label: "Part Catalog", icon: PackageSearch, testid: "nav-catalog" },
  { to: "/bulk-decode", label: "Bulk Decode", icon: Sparkles, testid: "nav-bulk-decode" },
  { to: "/shortage", label: "Shortage Report", icon: AlertTriangle, testid: "nav-shortage" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <aside
      data-testid="sidebar"
      className="bg-white border-r border-gray-200 w-64 flex flex-col h-screen fixed left-0 top-0 z-40"
    >
      <div className="px-6 py-6 border-b border-gray-100 flex items-center gap-2">
        <div className="w-8 h-8 rounded-md bg-slate-900 flex items-center justify-center text-white font-display font-bold text-sm">I</div>
        <div>
          <div className="font-display text-base font-semibold text-slate-900 leading-none">INDOCG Nexus</div>
          <div className="font-mono text-[10px] uppercase text-gray-400 tracking-widest mt-1">PO OS</div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors ${
                isActive
                  ? "bg-slate-900 text-white font-medium"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }`
            }
          >
            <Icon size={16} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-gray-100 p-4">
        {user && (
          <div className="flex items-center gap-3 mb-3">
            {user.picture ? (
              <img src={user.picture} alt={user.name} className="w-9 h-9 rounded-full border border-gray-200 object-cover" />
            ) : (
              <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 text-xs font-medium">
                {(user.name || user.email || "?")[0].toUpperCase()}
              </div>
            )}
            <div className="min-w-0">
              <div className="text-xs font-medium text-slate-900 truncate" data-testid="user-name">{user.name || user.email}</div>
              <div className="text-[11px] text-gray-500 truncate font-mono">{user.email}</div>
            </div>
          </div>
        )}
        <button
          onClick={handleLogout}
          data-testid="logout-btn"
          className="w-full inline-flex items-center gap-2 justify-center text-xs text-gray-600 border border-gray-200 rounded-md px-3 py-2 hover:bg-gray-50 hover:text-gray-900 transition-colors"
        >
          <LogOut size={14} /> Sign out
        </button>
      </div>
    </aside>
  );
}
